import { action, observable } from 'mobx';

// Транзит hover-связки «Розничные цены» → «Цены комплексов»: какой комплекс
// подсветить в таблице комплексов, пока курсор над его позицией в рознице.
// Мини-стор вместо useState в PriceListEditTableV3: запись из таблицы цен
// не должна перерисовывать саму таблицу (сотни инпутов) — реагирует только
// observer-разметка PriceListViewComplexTable.
export const complexRowHoverStore = observable({
  linkedComplexRefValueId: null as number | null,
});

export const complexRowHoverActions = {
  setLinkedComplexRefValueId: action((id: number | null) => {
    complexRowHoverStore.linkedComplexRefValueId = id;
  }),
};
